import React, { useCallback } from "react";
import AssignmentIcon from "@mui/icons-material/Assignment";
import FormValidation from "../../../components/FormValidation/FormValidation";
import formFields from "../../../config/formFields.json";

const AddProject = ({
  open,
  onClose,
  initialData = null,
  onSubmit,
  clients = [],
  clientDesignations = [],
  fetchClientPocs,
  clientPocs = [],
  onDependencyChange,
  resources = [],
  projectOwners = [],
  countries = [],
}) => {
  const isEdit = !!initialData;

  React.useEffect(() => {
    if (isEdit && initialData?.client_id) {
      fetchClientPocs(initialData.client_id.toString());
    }
  }, [isEdit, initialData?.client_id]);

  console.log("initialData", initialData, clientDesignations);
  const initialValues = {
    client_id: initialData?.client_id?.toString() || "",
    project_id: initialData?.project_id || "",
    project_name: initialData?.project_name || "",
    purchase_order_number: initialData?.purchase_order_number || "",
    project_description: initialData?.project_description || "",
    project_model: initialData?.project_model || "",
    project_type: initialData?.project_type || "",
    proposed_start_date: initialData?.proposed_start_date || "",
    proposed_end_date: initialData?.proposed_end_date || "",
    budget_hours: initialData?.budget_hours || "",
    is_active: initialData?.is_active ?? true,
    project_pocs: initialData?.project_pocs || [],
    primary_project_manager:
      initialData?.primary_project_manager?.toString() || "",
    secondary_project_manager:
      initialData?.secondary_project_manager?.toString() || "",
    project_owner: initialData?.project_owner?.toString() || "",
    project_poc_id:
      initialData?.project_pocs_mapping
        ?.find((poc) => !poc?.is_sponsor)
        ?.client_poc_id?.toString() || "",
    sponsor_id:
      initialData?.project_pocs_mapping
        ?.find((poc) => poc?.is_sponsor)
        ?.client_poc_id?.toString() || "",
    project_poc_business_unit:
      initialData?.project_pocs_mapping?.find(
        (item) => !item.is_sponsor && item?.project_pocs?.poc_business_unit
      )?.project_pocs?.poc_business_unit || "",
    project_poc_countries:
      initialData?.project_pocs_mapping
        ?.find(
          (item) => !item.is_sponsor && item?.project_pocs?.poc_business_unit
        )
        ?.project_pocs?.poc_country_name?.toString() || "",
    project_status_code: initialData?.project_status_code || "PENDING",
    auto_approve: initialData?.auto_approve == true ? true : false,
    publish_type:
      initialData?.publish_type === "APPROVED" ? initialData?.publish_type : "",
  };

  const getOptionsForField = useCallback(
    (source) => {
      switch (source) {
        case "client_id":
          return (
            clients?.map((client) => ({
              value: client.client_id.toString(),
              label: client.client_name,
            })) || []
          );
        case "clientDesignations":
          return (
            clientDesignations?.map((designation) => ({
              value: designation.client_designation_id.toString(),
              label: designation.client_designation_name,
            })) || []
          );
        case "poc_id":
          return Array.isArray(clientPocs)
            ? clientPocs.map((poc) => ({
                value: poc.client_poc_id.toString(),
                label: poc.poc_name,
              }))
            : [];
        case "primary_project_manager":
          return (
            resources?.map((resource) => ({
              value: resource.resource_id.toString(),
              label: `${resource.first_name} ${resource.last_name}`,
            })) || []
          );
        case "secondary_project_manager":
          return (
            resources?.map((resource) => ({
              value: resource.resource_id.toString(),
              label: `${resource.first_name} ${resource.last_name} `,
            })) || []
          );
        case "project_owner":
          return (
            projectOwners?.map((resource) => ({
              value: resource.resource_id.toString(),
              label: `${resource.first_name} ${resource.last_name}`,
            })) || []
          );
        case "project_poc_countries":
          return countries.map((country) => ({
            value: country.country_id.toString(),
            label: country.country_name,
          }));
        default:
          return [];
      }
    },
    [
      clients,
      clientDesignations,
      clientPocs,
      resources,
      projectOwners,
      countries,
    ]
  );

  return (
    <FormValidation
      open={open}
      onClose={onClose}
      initialData={initialValues}
      onSubmit={onSubmit}
      formFields={formFields.project.basic.fields}
      title="Project"
      icon={AssignmentIcon}
      getOptionsForField={getOptionsForField}
      isEdit={isEdit}
      modelWidth={"55vw"}
      onDependencyChange={onDependencyChange}
    />
  );
};

export default AddProject;
